"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationAreaCode = exports.CellId = void 0;
const binary_1 = require("../../binary");
const NAMESPACE = 'Network.Cellular.Gsm';
exports.CellId = binary_1.Uint16.annotations({
    identifier: `${NAMESPACE}.CellId`,
});
exports.LocationAreaCode = binary_1.Uint16.annotations({
    identifier: `${NAMESPACE}.LocationAreaCode`,
});
//# sourceMappingURL=gsm.js.map